import { Shelf } from "../../layout";
import { Body } from "../../typography";
import { Spinner } from "../Spinner";

export const TableLoader = () => {
  return (
    <Shelf spacing="small" role="status" aria-live="polite">
      <Spinner color="turquoise" />
      <Body>Loading</Body>
    </Shelf>
  );
};
